<template>
    <div class="container">
        <img src="http://assets.program.leadersir.cn/imgs/coin/coin_flag.png" class="flag">

        <div class="data_panel text_white">
            <div class="font30">创新币余额：</div>
            <div class="value bold mt-10" style="">
                {{ balance }} <img src="http://assets.program.leadersir.cn/imgs/coin/icon_coin-1.png"
                                   class="value_icon">
            </div>
            <div id="chart_container" style="margin-top: 30px;width: 100%;height: 40vh;max-height: 500px;"></div>
        </div>
    </div>

</template>

<script>
export default {
    name: "mine",

    data() {
        return {
            balance: 0,
            options: {
                xAxis: {
                    axisTick: {
                        alignWithLabel: true,
                        length: 1,
                        lineStyle: {
                            type: 'dotted',
                            color: '#fffff',
                            width: 6,
                            cap: 'round'
                        },
                    },
                    axisLabel: {
                        fontSize: 18,
                        margin: 20
                    },
                    type: 'category',
                    axisLine: {
                        lineStyle: {
                            color: 'white'
                        }
                    },
                    data: []
                },
                yAxis: {
                    show: false
                },
                series: [
                    {
                        data: [],
                        label: {
                            show: true,
                            fontSize: 20,
                            color: "#fff",
                            textBorderWidth: 0,
                        },
                        type: 'line',
                        symbol: 'image://http://assets.program.leadersir.cn/imgs/coin/icon_coin-2.png',
                        symbolSize: 36,
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255, 0.4)'
                        }
                    }
                ]
            }
        }
    },
    methods: {
        loadData() {
            this.$ajaxGet('/innovateScore/ownCoinInfo', res => {
                this.balance = res.result.balance;

                res.result.list.sort(function (a, b) {
                    return a.createTime < b.createTime ? -1 : 1;
                });

                this.options.xAxis.data = res.result.list.map(item => {
                    let date = new Date(item.createTime.replace(/-/g, '/'));
                    return date.format('MM.dd');
                });
                this.options.series[0].data = res.result.list.map(item => item.changeValue);

                this.$nextTick(() => {
                    let chart = this.echarts.init(document.getElementById("chart_container"));
                    chart.setOption(this.options);
                })
            })
        }
    },

    mounted() {
        this.loadData();
    }
}
</script>

<style scoped>
.container {
    background-image: url("http://assets.program.leadersir.cn/imgs/coin/coin_bg.png");
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;
}

.flag {
    position: absolute;
    width: 45%;
    max-width: 500px;
    top: 50%;
    left: 5%;
    transform: translateY(-40%);
}

.data_panel {
    position: absolute;
    width: 48%;
    left: 50%;
    top: 20%;
}

.value {
    font-family: fantasy;
    letter-spacing: 6px;
    font-size: 80px;
}

.value_icon {
    vertical-align: -8px;
}
</style>
